let elementName = `nss-buybox-summary-variant`;
if (typeof customElements.get(elementName) === `undefined`) {
  class NSSBuyboxSummary extends HTMLElement {
    constructor() {
      super();

      this.debug = false;
    }

    init() {
      this.id = this.getAttribute(`nss-variant-id`);
      this.els = {
        form: this.querySelector(`.shopify-product-form`),
        productSelect: this.querySelector(`[name="id"]`),
        quantity: this.querySelector(`[name="quantity"]`),
        planSelect: this.querySelector(`[name="selling_plan"]`),
        docEl: document.documentElement,
        selectedFrequencyName: document.querySelectorAll(
          `[nss-variant-id="${this.id}"] [nss-selected-frequency-name]`,
        ),
        planName: this.querySelector(`[nss-frequency-name]`),
        plans: this.querySelectorAll(`[nss-selling-plan-id]`),
        planMenu: this.querySelector(`[nss-plan-select]`),
        selectedPlanName: document.querySelector(
          `[nss-variant-id="${this.id}"] [nss-selected-plan-name]`,
        ),
        selectedPlanNameTitle: document.querySelectorAll(
          `[nss-variant-id="${this.id}"] [nss-selected-plan-name-title]`,
        ),
        qtyDown: this.querySelector(`[nss-qty-down]`),
        qtyUp: this.querySelector(`[nss-qty-up]`),
        qtyActual: this.querySelector(`[nss-qty-display-actual]`),
        qtyActualLabel: this.querySelector(`[nss-qty-display-actual-label]`),
        qtyTotal: this.querySelector(`[nss-qty-display-total]`),
        atcBtn: this.querySelector(`[nss-add-to-cart-btn]`),
        stickyATCs: this.querySelectorAll(`nss-buybox-sticky-atc-variant`),
        atcBtnOTP: this.querySelector(`[nss-add-to-cart-btn-otp]`),

        selectedSellingCount: document.querySelectorAll(
          `[nss-variant-id="${this.id}"] [nss-selling-count]`,
        ),
        selectedSellingServing: this.querySelectorAll(
          `[nss-variant-id="${this.id}"] [nss-selling-serving]`,
        ),
        selectedSellingSavingAmmount: this.querySelectorAll(
          `[nss-variant-id="${this.id}"] [nss-selling-saving-ammount]`,
        ),
        selectedSellingMostPopular: this.querySelectorAll(
          `[nss-variant-id="${this.id}"] [nss-selected-plan-most-popular]`,
        ),
      };
      this.currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      });
      this.sellingPlanId = this.els.planSelect ? this.els.planSelect.value : "";
      this.qtyMin = 1;
      this.qtyMax = 15;
      if (this.els.quantity) {
        this.inventory = this.els.quantity.getAttribute(`nss-inventory-qty`);
        this.inventoryPolicy =
          this.els.quantity.getAttribute(`nss-inventory-policy`);
        this.qtyMax = Math.min(15, this.inventory);
        /**
         * We don't need to use the policy in this case because we will always
         * deny - either due to lack of inventory (< 15) or at 15 total.
         */
      }
    }

    formatCurrency(value) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      const formatted = formatter.format(value);

      // Remove ".00" if it's at the end
      if (formatted.endsWith(".00")) {
        return formatted.slice(0, -3);
      }

      return formatted;
    }

    connectedCallback() {
      if (this.debug) console.log(`[NSS][Buybox Summary] Connected.`);

      this.init();

      this.addEventListener(`click`, this.clickHandler.bind(this));
      this.addEventListener(`buyboxUpdate`, this.updateHandler.bind(this));
      // this.addEventListener(`buyboxReload`, this.reloadHandler.bind(this));
      navigation.addEventListener(`navigate`, this.navigateHandler.bind(this));

      this.initQuantity();
    }

    navigateHandler(e) {
      if (this.debug) console.log(`[NSS][Buybox Summary] Navigation event, e:`, e);

      if (e.navigationType === "traverse") {
        const url = new URL(e.destination.url);
        const newId = url.searchParams.get(`variant`);
        if (newId === this.id) {
          this.updateEvent(newId);
        }
      }
    }

    async fetchSection() {
      const parser = new DOMParser();
      const sectionID = this.getAttribute(`nss-parent-section-id`);
      const markup = await (await fetch(`?section_id=${sectionID}`)).text();
      const dom = parser.parseFromString(markup, "text/html");
      return dom;
    }

    async reloadHandler() {
      const dom = await this.fetchSection();

      const selectorParent = `nss-buybox-summary-variant[nss-variant-id="${this.id}"]`;
      const selectorChild = `.nss-buybox-summary-variant__wrapper`;
      const selector = `${selectorParent} ${selectorChild}`;
      const newAtc = dom.querySelector(selector);
      const thisAtc = this.querySelector(selectorChild);
      thisAtc.replaceWith(newAtc);

      this.init();
    }

    atcBtnOTP() {
      const form = this.querySelector(".shopify-product-form");
      if (form) {
        const formData = new FormData(form);
        formData.delete("selling_plan");
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            window?.NSS_REFRESH_AND_OPEN_CART();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }

    initQuantity() {
      const plan = this.querySelector(`[nss-selling-plan-id]:checked`);
      if (plan) {
        const id = plan.getAttribute(`nss-selling-plan-id`);
        const name = plan.getAttribute(`nss-selling-plan-name `);
        const price = plan.getAttribute(`data-price`);
        const compareAtPrice = plan.getAttribute(`data-compare-at-price`);
        const planName = plan.getAttribute(`nss-plan-name`);
        const dataPerDay = plan.getAttribute(`data-per-day`);
        const dataSaving = plan.getAttribute(`data-saving`);
        const dataCount = plan.getAttribute(`data-count`);
        const dataMostPopular = plan.getAttribute(`data-most-popular`);
        const dataOTPPrice = plan.getAttribute(`data-otp-price`);
        const dataOTPCompareAtPrice = plan.getAttribute(
          `data-otp-compare-at-price`,
        );
        const dataOTPPerDay = plan.getAttribute(`data-otp-per-day`);

        if (this.debug) console.log(`[NSS][Buybox Summary] id:`, id);
        this.els.planSelect.value = id;
        this.sellingPlanId = id;
        if (this.els.selectedPlanName) {
          this.els.selectedPlanName.innerHTML = name;
        }
        if (plan.hasAttribute(`nss-frequency-name`)) {
          const freqName = plan.getAttribute(`nss-frequency-name`);
          this.els.selectedFrequencyName.forEach((el) => {
            el.innerHTML = freqName;
          });
          if (plan.hasAttribute("data-quantity") && this.els.quantity) {
            this.els.quantity.value = parseInt(
              plan.getAttribute("data-quantity"),
              0,
            );
          }

          this.els.selectedSellingMostPopular.forEach((el) => {
            el.innerHTML = dataMostPopular ? dataMostPopular : "";
            if (dataMostPopular == "") {
              el.style.display = "none";
            } else {
              el.style.display = "block";
            }
          });
          this.els.selectedPlanNameTitle.forEach((el) => {
            el.innerHTML = planName ? planName : "";
            if (planName == "") {
              el.style.display = "none";
            } else {
              el.style.display = "block";
            }
          });
          this.els.selectedSellingCount.forEach((el) => {
            el.innerHTML = dataCount ? dataCount : "";
            if (dataCount == "") {
              el.style.display = "none";
            } else {
              el.style.display = "block";
            }
          });
          document
            .querySelectorAll(
              `[nss-variant-id="${this.id}"] [nss-selling-serving]`,
            )
            .forEach((el) => {
              el.innerHTML = dataPerDay ? dataPerDay : "";
              if (dataPerDay == "") {
                el.style.display = "none";
              } else {
                el.style.display = "block";
              }
            });
          this.els.selectedSellingSavingAmmount.forEach((el) => {
            el.innerHTML = dataSaving ? dataSaving : "";
            if (dataSaving == "") {
              el.style.display = "none";
            } else {
              el.style.display = "block";
            }
          });
          document
            .querySelectorAll(
              `[nss-variant-id="${this.id}"] [nss-selected-otp-compare-at-price]`,
            )
            .forEach((item) => {
              if (dataOTPCompareAtPrice != "" && dataOTPCompareAtPrice != NaN) {
                item.innerText = this.currencyFormatter.format(
                  (this.els.quantity.value *
                    parseInt(dataOTPCompareAtPrice, 10)) /
                    100,
                );
              } else {
                item.innerText = "";
              }
            });
          document
            .querySelectorAll(
              ` [nss-variant-id="${this.id}"] [nss-selected-otp-price]`,
            )
            .forEach((item) => {
              if (dataOTPPrice != "" && dataOTPPrice != NaN) {
                item.innerText = this.currencyFormatter.format(
                  (this.els.quantity.value * parseInt(dataOTPPrice, 10)) / 100,
                );
              } else {
                item.innerText = "";
              }
            });
          document
            .querySelectorAll(
              ` [nss-variant-id="${this.id}"] [nss-selected-otp-per-day]`,
            )
            .forEach((item) => {
              if (dataOTPPerDay != "" && dataOTPPerDay != NaN) {
                item.innerText = this.formatCurrency(
                  parseInt(dataOTPPerDay, 10) / 100,
                );
              } else {
                item.innerText = "";
              }
            });
        }

        this.updatePrice(compareAtPrice, price);
        if (this.classList.contains("nss-active")) {
          this.updateEvent(this.id);
        }
      }
    }

    updatePrice(subCompareAtPrice, subPrice) {
      this.querySelectorAll(
        `[nss-selected-frequency-compare-at-price]`,
      ).forEach((item) => {
        item.setAttribute("data-price", subCompareAtPrice);
      });
      document
        .querySelectorAll(
          `[nss-variant-id="${this.id}"] [nss-selected-frequency-price]`,
        )
        .forEach((item) => {
          item.setAttribute("data-price", subPrice);
        });
      document
        .querySelectorAll(
          `[nss-variant-id="${this.id}"] [nss-selected-frequency-compare-at-price],[nss-variant-id="${this.id}"] [nss-selected-frequency-price]`,
        )
        .forEach((item) => {
          const price = item.getAttribute("data-price");
          if (price != "") {
            item.innerText = this.currencyFormatter.format(
              (this.els.quantity.value * parseInt(price, 10)) / 100,
            );
          } else {
            item.innerText = "";
          }
        });
    }

    updateURL() {
      const url = new URL(window.location.href);
      url.searchParams.set(`variant`, this.id);
      window.history.pushState({}, "", url);
    }

    clickHandler(e) {
      if (this.debug)
        console.log(`[NSS][Buybox Summary] Click - e.target:`, e.target);
      if (
        e.target.hasAttribute(`nss-add-to-cart-btn-otp`) ||
        e.target.closest(`[nss-add-to-cart-btn-otp]`)
      ) {
        this.atcBtnOTP();
        return;
      }
      if (
        e.target.hasAttribute(`nss-add-to-cart-btn`) ||
        e.target.closest(`[nss-add-to-cart-btn]`)
      ) {
        return;
      }
      if (e.target.hasAttribute(`nss-variant-id`)) {
        e.preventDefault();
        const newId = e.target.getAttribute(`nss-variant-id`);
        if (this.debug) console.log(`[NSS][Buybox Summary] newId:`, newId);
        this.updateEvent(newId);
      }

      if (e.target.hasAttribute(`nss-plan-select`)) {
        e.target.parentElement.classList.toggle(`nss-active`);
      }

      if (e.target.hasAttribute(`nss-selling-plan-id`)) {
        const id = e.target.getAttribute(`nss-selling-plan-id`);
        const name = e.target.getAttribute(`nss-selling-plan-name`);
        const price = e.target.getAttribute(`data-price`);
        const compareAtPrice = e.target.getAttribute(`data-compare-at-price`);
        const planName = e.target.getAttribute(`nss-plan-name`);
        const dataPerDay = e.target.getAttribute(`data-per-day`);
        const dataSaving = e.target.getAttribute(`data-saving`);
        const dataCount = e.target.getAttribute(`data-count`);
        const dataMostPopular = e.target.getAttribute(`data-most-popular`);
        const dataOTPPrice = e.target.getAttribute(`data-otp-price`);
        const dataOTPCompareAtPrice = e.target.getAttribute(
          `data-otp-compare-at-price`,
        );
        const dataOTPPerDay = e.target.getAttribute(`data-otp-per-day`);
        this.els.plans.forEach((planEl) =>
          planEl.parentElement.classList.remove(`nss-active`),
        );
        e.target.parentElement.classList.add(`nss-active`);
        if (this.debug) console.log(`[NSS][Buybox Summary] id:`, id);
        this.els.planSelect.value = id;
        this.sellingPlanId = id;
        if (this.els.planMenu) {
          this.els.planMenu.parentElement.classList.remove(`nss-active`);
        }
        if (this.els.selectedPlanName) {
          this.els.selectedPlanName.innerHTML = name;
        }
        if (e.target.hasAttribute(`nss-frequency-name`)) {
          const freqName = e.target.getAttribute(`nss-frequency-name`);
          this.els.selectedFrequencyName.forEach((el) => {
            el.innerHTML = freqName;
          });
          if (e.target.hasAttribute("data-quantity") && this.els.quantity) {
            this.els.quantity.value = parseInt(
              e.target.getAttribute("data-quantity"),
              0,
            );
          }

          this.els.selectedSellingMostPopular.forEach((el) => {
            el.innerHTML = dataMostPopular ? dataMostPopular : "";
            if (dataMostPopular == "") {
              el.style.display = "none";
            } else {
              el.style.display = "block";
            }
          });
          this.els.selectedPlanNameTitle.forEach((el) => {
            el.innerHTML = planName ? planName : "";
            if (planName == "") {
              el.style.display = "none";
            } else {
              el.style.display = "block";
            }
          });
          this.els.selectedSellingCount.forEach((el) => {
            el.innerHTML = dataCount ? dataCount : "";
            if (dataCount == "") {
              el.style.display = "none";
            } else {
              el.style.display = "block";
            }
          });

          document
            .querySelectorAll(
              `[nss-variant-id="${this.id}"] [nss-selling-serving]`,
            )
            .forEach((el) => {
              el.innerHTML = dataPerDay ? dataPerDay : "";
              if (dataPerDay == "") {
                el.style.display = "none";
              } else {
                el.style.display = "block";
              }
            });
          this.els.selectedSellingSavingAmmount.forEach((el) => {
            el.innerHTML = dataSaving ? dataSaving : "";
            if (dataSaving == "") {
              el.style.display = "none";
            } else {
              el.style.display = "block";
            }
          });
          document
            .querySelectorAll(
              `[nss-variant-id="${this.id}"] [nss-selected-otp-compare-at-price]`,
            )
            .forEach((item) => {
              console.log(dataOTPCompareAtPrice);
              if (dataOTPCompareAtPrice != "" && dataOTPCompareAtPrice != NaN) {
                item.innerText = this.currencyFormatter.format(
                  (this.els.quantity.value *
                    parseInt(dataOTPCompareAtPrice, 10)) /
                    100,
                );
              } else {
                item.innerText = "";
              }
            });
          document
            .querySelectorAll(
              ` [nss-variant-id="${this.id}"] [nss-selected-otp-price]`,
            )
            .forEach((item) => {
              if (dataOTPPrice != "" && dataOTPPrice != NaN) {
                item.innerText = this.currencyFormatter.format(
                  (this.els.quantity.value * parseInt(dataOTPPrice, 10)) / 100,
                );
              } else {
                item.innerText = "";
              }
            });
          document
            .querySelectorAll(
              ` [nss-variant-id="${this.id}"] [nss-selected-otp-per-day]`,
            )
            .forEach((item) => {
              if (dataOTPPerDay != "" && dataOTPPerDay != NaN) {
                item.innerText = this.formatCurrency(
                  parseInt(dataOTPPerDay, 10) / 100,
                );
              } else {
                item.innerText = "";
              }
            });

          this.updatePrice(compareAtPrice, price);

          this.updateEvent(this.id);
        }

        if (e.target.hasAttribute(`nss-otp`)) {
          this.els.planSelect.value = "";
          const name = e.target.getAttribute(`nss-frequency-name`);
          this.els.selectedFrequencyName.forEach((el) => {
            el.innerHTML = name;
          });
          this.updateEvent(this.id);
        }

        if (e.target.hasAttribute(`nss-sub`)) {
          this.els.planSelect.value = this.sellingPlanId;
          const name = e.target.getAttribute(`nss-frequency-name`);
          this.els.selectedFrequencyName.forEach((el) => {
            el.innerHTML = name;
          });
          this.updateEvent(this.id);
        }

        if (e.target.hasAttribute(`nss-qty-down`)) {
          let qty = parseInt(this.els.quantity.value);
          if (qty <= this.qtyMin) return;
          qty -= 1;
          this.updateQtys(qty);
          this.updateEvent(this.id);
        }

        if (e.target.hasAttribute(`nss-qty-up`)) {
          let qty = parseInt(this.els.quantity.value);
          if (qty >= this.qtyMax) return;
          qty += 1;
          this.updateQtys(qty);
          this.updateEvent(this.id);
        }
      }
    }

    updateQtys(qty) {
      if (qty > this.qtyMin) this.els.qtyDown.disabled = false;
      if (qty < this.qtyMax) this.els.qtyUp.disabled = false;
      if (qty <= this.qtyMin) this.els.qtyDown.disabled = true;
      if (qty >= this.qtyMax) this.els.qtyUp.disabled = true;
      if (qty < this.qtyMin) this.els.quantity.value = this.qtyMin;
      if (qty > this.qtyMax) this.els.quantity.value = this.qtyMax;
      this.els.quantity.value = qty;
      this.els.qtyActual.innerHTML = qty;
      if (qty > 1) {
        this.els.qtyActualLabel.innerHTML = `BOXES`;
      } else {
        this.els.qtyActualLabel.innerHTML = `BOX`;
      }
      this.els.qtyTotal.innerHTML = qty * 12;
    }

    updateEvent(newId) {
      if (this.debug) console.log(`[NSS][Buybox Summary] updateEvent - newId:`, newId);

      const updateEls = document.querySelectorAll(`[nss-buybox-update]`);
      updateEls.forEach((updateEl) => {
        const detail = {
          oldId: this.id,
          newId: newId,
          sellingPlanId: this.els.planSelect ? this.els.planSelect.value : null,
          quantity: this.els.quantity ? this.els.quantity.value : null,
        };
        const event = new CustomEvent("buyboxUpdate", { detail: detail });
        updateEl.dispatchEvent(event);
      });
    }

    updateHandler(e) {
      const oldId = e.detail.oldId;
      const newId = e.detail.newId;

      if (newId === this.id) {
        this.classList.add(`nss-active`);
        this.updateURL();

        // Update ATC text
        // if (this.els.atcBtn) {
        //     const atcSpanEl = this.els.atcBtn.querySelector(`span`);
        //     let atcText = "ADD TO CART";
        //     if (this.els.planSelect?.value !== "") {
        //         atcText = this.els.atcBtn.getAttribute(`nss-atc-sub-text`);
        //     } else {
        //         atcText = this.els.atcBtn.getAttribute(`nss-atc-otp-text`);
        //     }
        //     atcSpanEl.innerHTML = atcText;
        // }
      } else {
        this.els.planMenu?.parentElement.classList.remove(`nss-active`);
        this.classList.remove(`nss-active`);
      }
    }
  }

  customElements.define(elementName, NSSBuyboxSummary);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}

class NSSBuyboxBottom extends HTMLElement {
  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    this.id = this.getAttribute(`nss-variant-id`);
    this.addEventListener(`buyboxUpdate`, this.updateHandler.bind(this));
  }

  updateHandler(e) {
    const oldId = e.detail.oldId;
    const newId = e.detail.newId;
    if (newId === this.id) {
      this.classList.add(`nss-active`);
    } else {
      this.classList.remove(`nss-active`);
    }
  }
}

// ---------------------------------------------------------------------------
// Selling Plan Block initializer
// Called from blocks/nss-selling-plan.liquid: NSSSellingPlanInit('{{ block.id }}')
// ---------------------------------------------------------------------------
function initNSSSellingPlan(blockId) {
  var wrapper   = document.getElementById('nss-selling-plan-' + blockId);
  if (!wrapper) return;

  var planInput = document.getElementById('nss-selling-plan-input-' + blockId);
  if (!planInput) return;

  // Hide Seal Subscriptions default widget — we replace it with our custom UI
  document.querySelectorAll('.sealsubs-target-element').forEach(function (el) {
    el.remove();
  });

  function getSelectedPlanId() {
    var checkedRadio = wrapper.querySelector('.nss-selling-plan__radio:checked');
    if (!checkedRadio) return '';

    // Prefer the frequency select of the CHECKED card — with one selling plan
    // group per quantity tier, other (hidden) cards have their own selects.
    var card = checkedRadio.closest('.nss-selling-plan__option');
    var select = card ? card.querySelector('.nss-selling-plan__frequency-select') : null;
    if (select && select.value) return select.value;

    // Fall back to plan ID on the checked radio
    return checkedRadio.dataset.planId || '';
  }

  // Sync plan ID to any third-party selling_plan inputs (e.g. Seal Subscriptions)
  function syncThirdPartyInputs(planId) {
    document.querySelectorAll(
      'input[data-sls-selling_plan], input[name="selling_plan"]:not(#nss-selling-plan-input-' + blockId + ')'
    ).forEach(function (input) {
      input.value = planId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function getCurrentPrice() {
    var checkedRadio = wrapper.querySelector('.nss-selling-plan__radio:checked');
    if (!checkedRadio) return 0;

    if (checkedRadio.value === 'otp') {
      return parseInt(checkedRadio.dataset.price || 0, 10);
    }

    // Subscription: prefer the selected frequency option price of the CHECKED
    // card (other quantity tiers' hidden cards have their own selects)
    var card = checkedRadio.closest('.nss-selling-plan__option');
    var select = card ? card.querySelector('.nss-selling-plan__frequency-select') : null;
    if (select) {
      var selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.dataset.price) {
        return parseInt(selectedOption.dataset.price, 10);
      }
    }

    return parseInt(checkedRadio.dataset.price || 0, 10);
  }

  function updatePlanInput() {
    var checkedRadio = wrapper.querySelector('.nss-selling-plan__radio:checked');
    if (!checkedRadio) return;

    if (checkedRadio.value === 'otp') {
      planInput.value    = '';
      planInput.disabled = true;
      syncThirdPartyInputs('');
    } else {
      planInput.disabled = false;
      planInput.value    = getSelectedPlanId();
      syncThirdPartyInputs(planInput.value);
    }

    // Notify buy button + sticky bar (planId "" = One-Time Purchase)
    document.dispatchEvent(new CustomEvent('nss:sellingplanchange', {
      detail: {
        price: getCurrentPrice(),
        planId: planInput.disabled ? '' : (planInput.value || '')
      }
    }));
  }

  // Radio change: OTP ↔ subscription
  wrapper.querySelectorAll('.nss-selling-plan__radio').forEach(function (radio) {
    radio.addEventListener('change', updatePlanInput);
  });

  // ---------------------------------------------------------------------
  // OTP card price: reflect the selected quantity tier's OTP display
  // discount (data-otp-discount on the quantity radio — mirrors the admin
  // automatic discount). Shows the discounted unit price + strikethrough.
  // ---------------------------------------------------------------------
  function updateOtpOptionPrice() {
    var priceEl = wrapper.querySelector('[nss-otp-option-price]');
    if (!priceEl) return;
    var base = parseInt(priceEl.getAttribute('data-base-price'), 10);
    if (!base) return;

    var qtyRadio = document.querySelector('input[name="quantity"]:checked');
    var disc = qtyRadio ? parseFloat(qtyRadio.getAttribute('data-otp-discount')) : 0;
    if (isNaN(disc) || disc < 0) disc = 0;

    var formatEl = document.querySelector('.nss-product-form__submit-price');
    var moneyFormat = formatEl ? formatEl.dataset.moneyFormat : null;
    function formatMoney(cents) {
      if (moneyFormat && window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      var d = Math.floor(cents / 100);
      var c = cents % 100;
      return '$' + d + '.' + (c < 10 ? '0' : '') + c;
    }

    // Shopify floors the per-unit discount amount to the cent (e.g. 10% of
    // $15.89 = 158.9¢ → 158¢ off → $14.31/unit → $28.62 for 2) — match it so
    // unit × qty equals the cart total exactly.
    var unit = disc > 0 ? base - Math.floor((base * disc) / 100) : base;
    priceEl.textContent = formatMoney(unit);

    var compareEl = wrapper.querySelector('[nss-otp-option-compare]');
    if (compareEl) compareEl.style.display = disc > 0 ? '' : 'none';
  }

  // ---------------------------------------------------------------------
  // Quantity-tier selling plan groups: each quantity option carries its
  // group id (data-spg-id on the quantity radio). Show only that group's
  // card; hide the rest. Fallback: the first sub card (matches Liquid's
  // default when a product has no tier settings).
  // ---------------------------------------------------------------------
  function syncGroupVisibility() {
    var cards = wrapper.querySelectorAll('[data-nss-sp-option="sub"]');
    if (cards.length < 2) return; // nothing to toggle

    var qtyRadio = document.querySelector('input[name="quantity"]:checked');
    var gid = qtyRadio ? (qtyRadio.getAttribute('data-spg-id') || '') : '';
    var qty = qtyRadio ? parseInt(qtyRadio.value, 10) : NaN;

    // Prefer the explicit quantity↔card mapping (data-nss-sp-quantity):
    // highest tier <= selected qty, so tier 3 also covers "3 and up".
    var target = null;
    if (!isNaN(qty)) {
      var bestQty = -1;
      cards.forEach(function (card) {
        var q = parseInt(card.getAttribute('data-nss-sp-quantity'), 10);
        if (!isNaN(q) && q <= qty && q > bestQty) {
          bestQty = q;
          target = card;
        }
      });
    }
    // Fall back to group-id match, then the first card
    if (!target && gid) {
      cards.forEach(function (card) {
        if (!target && card.getAttribute('data-nss-sp-group') === gid) target = card;
      });
    }
    if (!target) target = cards[0];

    var checkedRadio = wrapper.querySelector('.nss-selling-plan__radio:checked');
    var wasSub = !!(checkedRadio && checkedRadio.value !== 'otp');

    cards.forEach(function (card) {
      var isTarget = card === target;
      card.hidden = !isTarget;
      var radio = card.querySelector('.nss-selling-plan__radio');
      if (!isTarget && radio) radio.checked = false;
    });

    // Keep "subscription" selected across quantity changes — move the
    // checked state to the newly visible group's radio.
    if (wasSub) {
      var targetRadio = target.querySelector('.nss-selling-plan__radio');
      if (targetRadio) targetRadio.checked = true;
    }
    updatePlanInput();
  }

  // Quantity selector radios live outside this block — listen on document
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'quantity') {
      syncGroupVisibility();
      updateOtpOptionPrice();
    }
  });

  // Keep the visible "Delivery every <value>" label + the "Total savings"
  // line in sync with the select
  function syncFrequencyLabel(select) {
    var opt = select.options[select.selectedIndex];

    var frequency = select.closest('.nss-selling-plan__frequency');
    var current = frequency && frequency.querySelector('[data-nss-sp-current]');
    if (current && opt) current.textContent = opt.textContent.trim();

    var card = select.closest('.nss-selling-plan__option');
    var savingsEl = card && card.querySelector('[data-nss-sp-savings]');
    if (savingsEl && opt) {
      var savings = parseFloat(opt.getAttribute('data-savings'));
      var wrap = savingsEl.closest('.nss-selling-plan__total-savings');
      if (!isNaN(savings) && savings > 0) {
        // Whole numbers without decimals ("15%"), fractions as-is ("18.99%")
        var savingsText = savings % 1 === 0 ? String(Math.round(savings)) : String(savings);
        savingsEl.textContent = savingsText + '% Off';
        if (wrap) wrap.style.display = '';
      } else if (wrap) {
        wrap.style.display = 'none';
      }
    }
  }

  // Frequency select change: update plan ID, ensure sub radio is checked
  wrapper.querySelectorAll('.nss-selling-plan__frequency-select').forEach(function (select) {
    syncFrequencyLabel(select);
    select.addEventListener('change', function () {
      var subRadio = wrapper.querySelector('.nss-selling-plan__radio[value^="sub"]');
      if (subRadio && !subRadio.checked) {
        subRadio.checked = true;
      }
      syncFrequencyLabel(select);
      updatePlanInput();
    });
  });

  // Apply a plan id from an external source (e.g. the sticky bar). "" = One-Time Purchase.
  function applyPlanId(planId) {
    planId = planId == null ? '' : String(planId);

    if (planId === '') {
      var otpRadio = wrapper.querySelector('.nss-selling-plan__radio[value="otp"]');
      if (otpRadio) otpRadio.checked = true;
      updatePlanInput();
      return;
    }

    // Prefer a frequency select that contains this plan id
    var targetSelect = null;
    wrapper.querySelectorAll('.nss-selling-plan__frequency-select').forEach(function (sel) {
      if (targetSelect) return;
      var found = Array.prototype.some.call(sel.options, function (o) { return o.value === planId; });
      if (found) targetSelect = sel;
    });

    if (targetSelect) {
      targetSelect.value = planId;
      syncFrequencyLabel(targetSelect);
      var card = targetSelect.closest('.nss-selling-plan__option');
      var subRadio = card && card.querySelector('.nss-selling-plan__radio');
      if (subRadio) subRadio.checked = true;
    } else {
      // Single-plan group: match a sub radio by its data-plan-id
      wrapper.querySelectorAll('.nss-selling-plan__radio').forEach(function (r) {
        if (r.dataset.planId === planId) r.checked = true;
      });
    }
    updatePlanInput();
  }

  // Listen for the sticky bar (or any other UI) setting the plan
  document.addEventListener('nss:setsellingplan', function (e) {
    applyPlanId(e.detail && e.detail.planId);
  });

  // Init: OTP is checked by default — disable selling_plan so it isn't submitted
  planInput.value    = '';
  planInput.disabled = true;
  syncThirdPartyInputs('');

  // Align visible group + OTP price with the initially checked quantity radio
  syncGroupVisibility();
  updateOtpOptionPrice();

  // Dispatch initial price/plan so buy button + sticky bar sync on load
  document.dispatchEvent(new CustomEvent('nss:sellingplanchange', {
    detail: { price: getCurrentPrice(), planId: '' }
  }));
}

window.NSSSellingPlanInit = initNSSSellingPlan;

// ---------------------------------------------------------------------------
// Buy Buttons Block custom element
// Replaces NSSBuyButtonsInit + NSSProductFormSpinnerInit — no block ID needed.
// ---------------------------------------------------------------------------
if (typeof customElements.get('nss-buy-buttons-block') === 'undefined') {
  class NSSBuyButtonsBlock extends HTMLElement {
    connectedCallback() {
      this.initPrice();
      this.initSpinner();
    }

    initPrice() {
      var priceEl = this.querySelector('.nss-product-form__submit-price');
      if (!priceEl) return;

      var basePrice   = parseInt(priceEl.dataset.basePrice, 10);
      var moneyFormat = priceEl.dataset.moneyFormat;
      var isSub       = false;

      function formatMoney(cents) {
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        var dollars = Math.floor(cents / 100);
        var c = cents % 100;
        return '$' + dollars + '.' + (c < 10 ? '0' : '') + c;
      }

      // Apply a percentage discount to a line total the way Shopify's cart
      // does: round the discount on the line subtotal, then subtract.
      function lineTotal(unit, qty, discountPct) {
        var subtotal = unit * qty;
        if (discountPct > 0) {
          return subtotal - Math.round((subtotal * discountPct) / 100);
        }
        return subtotal;
      }

      function updatePrice() {
        var qtyRadio = document.querySelector('input[name="quantity"]:checked');
        var qty = qtyRadio ? parseInt(qtyRadio.value, 10) : 1;
        if (!qty || qty < 1) qty = 1;

        if (isSub) {
          // Subscription: basePrice is the selected frequency's per-delivery
          // price from the quantity tier's own selling plan group — that group
          // already carries the tier's pricing, so NO extra discount is
          // applied. Total = plan price × qty.
          priceEl.textContent = formatMoney(lineTotal(basePrice, qty, 0));
          return;
        }

        // One-time: prefer the pre-computed, discount-inclusive line total the
        // quantity selector renders onto the checked radio. Fall back to
        // base * qty for fallback/variant radios that carry no total.
        if (qtyRadio) {
          var stored    = qtyRadio.getAttribute('data-otp-price');
          var storedInt = parseInt(stored, 10);
          if (stored !== null && stored !== '' && !isNaN(storedInt) && storedInt > 0) {
            priceEl.textContent = formatMoney(storedInt);
            return;
          }
        }

        priceEl.textContent = formatMoney(basePrice * qty);
      }

      // Listen for quantity radio changes
      document.addEventListener('change', function (e) {
        if (e.target.name === 'quantity') updatePrice();
      });

      // Listen for variant changes (resets to OTP price for the new variant)
      document.addEventListener('nss:variantchange', function (e) {
        if (e.detail && e.detail.price) {
          basePrice = e.detail.price;
          updatePrice();
        }
      });

      // Listen for selling plan changes (OTP vs subscription price)
      document.addEventListener('nss:sellingplanchange', function (e) {
        if (e.detail) {
          isSub = !!e.detail.planId;
          if (e.detail.price) basePrice = e.detail.price;
          updatePrice();
        }
      });

      updatePrice();
    }

    initSpinner() {
      var btn = this.querySelector('.nss-product-form__submit');
      if (!btn) return;

      var productForm = btn.closest('product-form');
      if (!productForm) return;

      var form = btn.closest('form');
      if (!form) return;

      var spinner = productForm.querySelector('.loading__spinner');
      if (!spinner) return;

      function showSpinner() {
        spinner.classList.remove('hidden');
        btn.setAttribute('aria-disabled', 'true');
      }

      function hideSpinner() {
        spinner.classList.add('hidden');
        btn.removeAttribute('aria-disabled');
      }

      // product-form.js does the same — this is a safety net for missing cart elements
      form.addEventListener('submit', function () {
        showSpinner();
        var timeout = setTimeout(hideSpinner, 10000);
        document.addEventListener('nss:cartUpdated', function onUpdate() {
          clearTimeout(timeout);
          hideSpinner();
          document.removeEventListener('nss:cartUpdated', onUpdate);
        }, { once: true });
      });
    }
  }

  customElements.define('nss-buy-buttons-block', NSSBuyButtonsBlock);
}

// ---------------------------------------------------------------------------
// Price Comparison block custom element
// Replaces NSSPriceComparisonInit — scoped to each block instance.
// ---------------------------------------------------------------------------
if (typeof customElements.get('nss-price-comparison-block') === 'undefined') {
  class NSSPriceComparisonBlock extends HTMLElement {
    connectedCallback() {
      var self = this;

      function formatMoney(cents, format) {
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents, format);
        }
        var d = Math.floor(cents / 100);
        var c = cents % 100;
        return '$' + d + '.' + (c < 10 ? '0' : '') + c;
      }

      function updatePrice(cents) {
        self.querySelectorAll('[data-belive-price]').forEach(function (el) {
          el.textContent = formatMoney(cents, el.dataset.moneyFormat);
        });
      }

      // Only variant changes update this price. Selling plan / frequency
      // selections are deliberately ignored — the comparison row always
      // shows the original one-time price (vs Amazon/TikTok list prices).
      document.addEventListener('nss:variantchange', function (e) {
        if (e.detail && e.detail.price) updatePrice(e.detail.price);
      });
    }
  }

  customElements.define('nss-price-comparison-block', NSSPriceComparisonBlock);
}

// ---------------------------------------------------------------------------

let elementName2 = `nss-buybox-bottom`;

if (typeof customElements.get(elementName2) === `undefined`) {
  customElements.define(elementName2, NSSBuyboxBottom);
}
